var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-time",style:(_vm.styleColor)},[_c('TagDateRange',{attrs:{"size":"small"},on:{"change":_vm.onChange},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }